module.exports = __webpack_public_path__ + "img/two-section-left.bdf9c39a.png";